import { takeEvery, takeLatest } from 'redux-saga/effects';
import { FILTER_TEMPLATE_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_FILTER_TEMPLATE_BY_ID,
  LOAD_FILTER_TEMPLATE_LIST,
} from '../actions';
import loadFilterTemplateList from './loadFilterTemplateList';
import loadFilterTemplateById from './loadFilterTemplateById';

export default function* watchClient() {
  yield takeLatest(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST, loadFilterTemplateList);
  yield takeEvery(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID, loadFilterTemplateById);
}
